import { render } from "./ArticleListWidget.vue?vue&type=template&id=45d68cde&ts=true"
import script from "./ArticleListWidget.vue?vue&type=script&lang=ts"
export * from "./ArticleListWidget.vue?vue&type=script&lang=ts"

import "./ArticleListWidget.vue?vue&type=style&index=0&id=45d68cde&lang=css"
/* custom blocks */
import block0 from "./ArticleListWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__